import styled from 'styled-components/macro';
import { colors } from '../../../styles/variables';

export const Container = styled.div`
  font-size: 0.9rem;
  margin-top: 1.8em;
`;

export const List = styled.ul``;

export const Item = styled.li`
  color: ${colors.red};
  list-style: disc;
  list-style-position: inside;
  margin-top: 5px;
`;

export const Text = styled.p``;
